import React, { Component } from 'react';
import {array, func, string} from 'prop-types';

import ShowCase from '@components/ShowCase/ShowCase';
import Preview from '@components/ShowCase/Preview/Preview';
import Controls from '@components/ShowCase/Controls/Controls';

export default class BadgeShowcase extends Component {

  static propTypes = {
    component: func.isRequired,
    optionsGroup: array,
    backgrounds: array,
    codeTemplate: string,
  };

  render() {
    const { component, optionsGroup, backgrounds, codeTemplate } = this.props;

    return (
      <ShowCase codeTemplate={codeTemplate}>
        <Preview>
          {(componentProps) => component(componentProps)}
        </Preview>
        <Controls optionsGroup={optionsGroup} backgrounds={backgrounds} />
      </ShowCase>
    );
  }
}


// WEBPACK FOOTER //
// ./src/containers/elements/Badges/BadgeShowcase.js